module.exports = __webpack_public_path__ + "img/gamedev.fab208c4.jpg";